import { fromFetch } from 'rxjs/fetch';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { ruleSchema } from '../schemas/rule.schema';

/**
 * Gets one rule based on ID
 * @param id The ID of the rule being retrieved
 * @returns A rule
 */
export function getRulesId(this: unknown, id: number) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${mapManagementServiceEnvironment.resolve(this).rulesUrl}/${id}`,
        {
          method: 'GET',
          headers: {
            ...requiredHeaders,
            ...jwtAuthHeaders,
          },
        }
      )
    )
  ).pipe(selectData(ruleSchema));
}
